/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesRiotAccountSchema } from "./riotAccountSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesChampionMasterySchema = z.object({
  id: z.optional(z.int()),
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  riotAccountId: z.string().nullish(),
  get riotAccount() {
    return goodLuckCoreEntitiesRiotAccountSchema.optional();
  },
  championId: z.optional(z.int()),
  championName: z.string().nullish(),
  championLevel: z.optional(z.int()),
  championPoints: z.optional(z.int()),
  lastPlayTime: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
});
